import { Alert, Grid, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react';
import shortid from 'react-key-string';

import {
  MODAL_TYPE_BOT_HIDE,
  MODAL_TYPE_BOT_HIDE_OFF,
  MODAL_TYPE_BOT_INSTALL,
  MODAL_TYPE_BOT_UNINSTALL,
} from '../../common/consts';
import NewModal from '../NewModal';
import RobotFindSelectForm from '../RobotFindSelectForm';

const BotModal = ({
  type,
  open,
  bots,
  robots,
  messages,
  onConfirm,
  onCancel,
}) => {
  const [[title, prevent], setInfo] = useState([['', false]]);
  const [search, setSearch] = useState('');
  const [searchResult, setSearchResult] = useState([]);
  const [selectedItems, setSelected] = useState([]);

  const matches = useMediaQuery('(max-width:600px)');

  const onSearchChange = (event) => {
    const { value } = event.target;
    setSearch(value);
    const result = [...robots].reduce((prev, curr) => {
      const { serial, group, alias, id } = curr;
      const searchValue = new RegExp(value, 'ig');
      if (
        (serial && serial.search(searchValue) > -1) ||
        (group && 'name' in group && group.name.search(searchValue) > -1) ||
        (alias && alias.search(searchValue) > -1)
      ) {
        prev.push({
          id,
          serial,
          group,
          alias,
        });
      }
      return prev;
    }, []);
    setSearchResult(result);
  };

  const onItemSelectClick = ({ id }) => {
    const newItems = [...selectedItems];
    const selected = robots.find(({ id: robotId }) => robotId === id);

    if (selected) {
      newItems.push(selected);
      setSelected(newItems);
      setSearchResult(searchResult.filter((item) => !newItems.includes(item)));
    }
  };

  const onItemDeselectClick = (id) => {
    const newItems = selectedItems.filter((item) => item.id !== id);
    setSelected(newItems);
    setSearchResult(robots.filter((item) => !newItems.includes(item)));
  };

  const getButton = () => {
    switch (type) {
      case MODAL_TYPE_BOT_UNINSTALL:
        return { label: '선택 제거', color: 'error' };
      case MODAL_TYPE_BOT_HIDE_OFF:
        return { label: '선택 숨김해제' };
      case MODAL_TYPE_BOT_INSTALL:
        return { label: '선택 설치' };
      default:
        return { label: '선택 숨김' };
    }
  };

  const getContent = () => {
    switch (type) {
      case MODAL_TYPE_BOT_UNINSTALL:
        return '봇을 제거할 로봇을 검색 및 선택하세요.';
      case MODAL_TYPE_BOT_HIDE_OFF:
        return '봇을 숨김 해제할 로봇을 검색 및 선택하세요.';
      case MODAL_TYPE_BOT_INSTALL:
        return '봇을 설치할 로봇을 검색 및 선택하세요.';
      default:
        return '봇을 숨길 로봇을 검색 및 선택하세요.';
    }
  };

  const getTitle = (data) => {
    const [titleArr, preventArr] = data.reduce(
      (prev, { name: n, prevent: p }) => {
        if (
          p &&
          (type !== MODAL_TYPE_BOT_HIDE || type !== MODAL_TYPE_BOT_HIDE_OFF)
        ) {
          prev[1].push(n);
        }
        prev[0].push(n);
        return prev;
      },
      [[], []],
    );

    setInfo([
      titleArr.join(', '),
      preventArr.length > 0
        ? `${preventArr.join(', ')} 봇은 설치 및 제거가 불가능한 봇입니다.`
        : '',
    ]);
  };

  const handleClick = () => {
    onConfirm({ robots: selectedItems, bots });
  };

  const updateButtons = [
    { label: '취소', onClick: () => onCancel() },
    {
      ...getButton(),
      onClick: handleClick,
      disabled: !title || (title && selectedItems.length === 0),
    },
  ];

  useEffect(() => {
    if (open) {
      getTitle(bots);
      setSearchResult(robots);
    } else {
      setInfo([['', false]]);
      setSearch('');
      setSearchResult([]);
      setSelected([]);
    }
  }, [open]);

  return (
    <NewModal open={open} buttons={updateButtons} onClose={onCancel}>
      <Grid container spacing={1} sx={{ width: matches ? '100%' : '600px' }}>
        <Grid item xs={12}>
          <Typography variant="h5">{title}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography color="text.secondary">{getContent()}</Typography>
        </Grid>
        {prevent && (
          <Grid item xs={12}>
            <Alert color="error">{prevent}</Alert>
          </Grid>
        )}
        <Grid item xs={12}>
          {/* {robots.length === 0 && <Alert color="warning">{getMsg()}</Alert>} */}
          {messages.length > 0 &&
            messages.map((msg) => (
              <Alert color="warning" key={shortid.generate()} sx={{ mb: 1 }}>
                {msg}
              </Alert>
            ))}
          {robots.length > 0 && (
            <RobotFindSelectForm
              {...{
                input: search,
                list: searchResult,
                selected: selectedItems,
                onChange: onSearchChange,
                onSelect: onItemSelectClick,
                onDeselect: onItemDeselectClick,
              }}
            />
          )}
        </Grid>
      </Grid>
    </NewModal>
  );
};

export default BotModal;
